// extracted by mini-css-extract-plugin
export default {"root":"Home_root__1I252","bodyWrapper":"Home_bodyWrapper__Wbh8v","mobilesearch":"Home_mobilesearch__sLYdL"};